import { profileAdapter } from "@/services/adapters";

export function profileTransformResponse(data) {
  data = JSON.parse(data);
  if (data?.user) data.user = profileAdapter(data.user);
  return data;
}
